<template lang="pug">
v-app
  v-snackbar(:value="!backendconnected" bottom multi-line :timeout="0" color="error") Der Server ist momentan nicht erreichbar, bitte versuche es später erneut.
  v-app-bar(app dark).align-center.justify-center.d-flex
    v-img.shrink.hidden-xs-and-down.logo(alt="Colosseum Logo" contain min-width="320" src="./assets/colologo.png" width="320" @click="$router.push('/')")
  v-content
    v-container(style="max-width: 900px")
      router-view
  //- v-footer(app elevation="8").secondary
    v-spacer
    div &copy; FitnessStudio Colosseum {{new Date().getFullYear()}}

</template>

<script>
export default {
  name: "App",
  mounted() {
    window.vue = this
    const self = this

    self.socket.on("reconnect_attempt", () => {
      self.backendconnected = false
    })
    self.socket.on("connect", () => {
      self.backendconnected = true
    })

    document.title = `colo-app${self.dev ? "-dev" : ""} - ${self.$route.name}`
    self.$router.beforeEach((to, from, next) => {
      document.title = `colo-app${self.dev ? "-dev" : ""} - ${to.name}`
      next()
    })
  },
  data: () => ({
    backendconnected: true,
  }),
}
</script>

<style lang="stylus">
.logo
  cursor: pointer
</style>